import type { FaireProductEntity } from "../../entity_types/product";

export const p_2s6a8h3v5t: FaireProductEntity = {
  token: "p_2s6a8h3v5t",
  type: "product",
  name: "Sagebrush Bulk Bag (5lb, Certified Organic)",
  brandToken: "b_50b0t2xt",
  brandName: "Canyon Coffee",
  imageUrl: "https://cdn.faire.com/fastly/6cd6c70eda3b13f952174ede8148c7bb0c15da5ab39169389f820d444d037a1e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/de2ee1cf4d1f79b26a40af3049302c6c9ca964dbb40485c7d6a7e19b84c2e922.jpeg"
  ],
  priceDollars: 73.7,
  description: "Sagebrush is crafted to be the perfect daily cup of drip coffee — the kind we want to enjoy, black or with milk, every morning. We source Sagebrush from new and emerging farmers and co-ops making efforts to improve their ecological sustainability and economic well-being of workers.",
  tags: [],
  msrpDollars: 147.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:31.693Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
